import logo from "./logo.svg";
import "./App.css";
import theva from "./img/rajan.jpg";

import home from "./home";
import Biography from "./Biography";
import RI from "./RI";
import UT from "./UT";
import PA from "./PA";

import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink,
  Switch,
} from "react-router-dom";
import { useTheme } from "@material-ui/core";

function App() {
  return (
    <Router>
      <div className="App">
        <div class="text-xs md:text-center p-1 font-bold">
          <p>
            Welcome to the Personal website of Mr Thayananthan Thevathayarajh!
          </p>
        </div>
        <div class="grid grid-cols-2 items-center justify-center p-1 bg-gradient-to-r from-white via-cyan-200 to-blue-200">
          <div class="pt-6 p-8  space-y-2">
            <p class="text:base sm:text-lg md:text-5xl text-right text-black font-bold">
              Mr Thevathayarajh Thayananthan
            </p>

            <div class="text-blue-600 text-xs text-right sm:text-base md:text-2xl font-medium">
              <p>BTech (Hons) in Mechatronics</p>

              <p>Tp: +94776187658</p>
              <p>Email: theva1993@gmail.com</p>
            </div>
          </div>
          <figure>
            <img
              class="w-24 h-24 sm:h-32 sm:w-32 md:h-96 md:w-96 rounded-full "
              src={theva}
              alt="Theva's Face"
            ></img>
          </figure>
        </div>
        <div class="box-content h-50 w-300 p-0.1 sm:h-10 sm:w-300 sm:p-4 border-1 border-blue-400 ">
          <div class="h-full w-full  text-xs sm:text-xs md:text-lg">
            <div class="grid grid-cols-5 gap-y-2 gap-1 sm:grid-cols-5 sm:p-0 sm:gap-1 ">
              <NavLink exact activeClassName="active" to="/">
                <button class="w-full h-10 sm:w-28 md:w-40 bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500 text-white font-semibold  border border-blue-500 hover:border-transparent rounded focus:from-pink-500 focus:to-yellow-500 focus:border-transparent">
                  Home
                </button>
              </NavLink>
              <NavLink activeClassName="active" to={"/Biography"}>
                <button class="w-full h-10 sm:w-28 md:w-40 bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500 text-white font-semibold  border border-blue-500 hover:border-transparent rounded focus:from-pink-500 focus:to-yellow-500 focus:border-transparent">
                  Biography
                </button>
              </NavLink>
              <NavLink activeClassName="active" to={"/RI"}>
                <button class="w-full h-10 sm:w-28 md:w-40  text-center bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500 text-white font-semibold border border-blue-500 hover:border-transparent rounded focus:from-pink-500 focus:to-yellow-500 focus:border-transparent">
                  R-Interests
                </button>
              </NavLink>
              <NavLink activeClassName="active" to={"/UT"}>
                <button class="w-full sm:w-28 md:w-40 h-10  bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500 text-white font-semibold  border border-blue-500 hover:border-transparent rounded focus:from-pink-500 focus:to-yellow-500 focus:border-transparent">
                  Units Taught
                </button>
              </NavLink>
              <NavLink activeClassName="active" to={"/PA"}>
                <button class="w-full sm:w-28 md:w-40 h-10  bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500 text-white font-semibold  border border-blue-500 hover:border-transparent rounded focus:from-pink-500 focus:to-yellow-500 focus:border-transparent">
                  Publications
                </button>
              </NavLink>
            </div>
          </div>
        </div>
        <Switch>
          <Route exact path="/" component={home} />
          <Route path="/Biography" component={Biography} />
          <Route path="/RI" component={RI} />
          <Route path="/UT" component={UT} />
          <Route path="/PA" component={PA} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
